/* eslint-env browser */
/* global $ */

const $filters = $('.product-list-filters');
const $inputs = $filters.find('input');
const filterParams = {};
const $btnToggleForm = $('[data-action="toggle-filter-list"]');

function inputChange() {

	const $input = $(this);
	const type = $input.attr('name');
	const value = $input.val();
	const $currentTypeFilters = $inputs.filter(`[name="${type}"]`);

	filterParams[type] = [];

	if (value === '-1') {
		$currentTypeFilters.prop('checked', false);
		$input.prop('checked', true);
	} else {
		$currentTypeFilters.filter('[value="-1"]').prop('checked', false);
	}

	if ($currentTypeFilters.filter(':checked').length < 1) {
		$currentTypeFilters.filter('[value="-1"]').prop('checked', true);
	}

	const $currentlyChecked = $currentTypeFilters.filter(':checked');

	$.each($currentlyChecked, function () {
		filterParams[type].push(parseInt($(this).val(), 10));
	});

	$(document).trigger('filter-change.product-list', [filterParams]);

}

function init() {

	if (!$filters.length) {
		return;
	}

	$inputs.each(function () {
		filterParams[$(this).attr('name')] = null;
	});

	$btnToggleForm.on('click', function () {
		const $self = $(this);
		const $parent = $self.closest('.filter');
		const $btn = $parent.find('.btn--toggle-filter-list');
		const $target = $parent.find('.filter-form');

		$target.stop().slideToggle();
		$btn.toggleClass('is--active');

	});

	$filters.on('change', 'input', inputChange);

	// Change event

	// $(document).on('filter-change.product-list', (e, filterParams) => {

	// 	$inputs.prop('checked', false);

	// 	$.each(filterParams, function (type, id) {

	// 		let $activeInputs;

	// 		if (id) {
	// 			$activeInputs = $inputs.filter(`[name="${type}"]`).filter(function () {
	// 				return $(this).val() === id;
	// 			});
	// 		} else {
	// 			$activeInputs = $inputs.filter(`[name="${type}"]`).filter(function () {
	// 				return !$(this).val();
	// 			});
	// 		}

	// 		$activeInputs.prop('checked', true);

	// 	});

	// });

	$(document).trigger('filter-change.product-list', [filterParams]);

}

export default {
	init
};
